import type { Shop } from '@prisma/client'
import type { SerializeFrom } from '@remix-run/node'

import type { CartFull } from '~/models/cart.server'
import type { ShippingCountryCode } from '~/schemas/country'
import type { ShopShippingOptions } from '~/schemas/shop'

export const getTotalCartProducts = (cart: SerializeFrom<CartFull>) => {
  return (
    cart?.cartLines
      .filter((line) => line.productVariant.product.archivedAt == null)
      .reduce((n, { quantity }) => n + quantity, 0) || 0
  )
}

export const isValidShippingCountry = (
  countryCode: ShippingCountryCode | undefined,
  shop: Shop
) => {
  if (!countryCode) return null

  const availableCountries =
    (shop.shippingOptions as ShopShippingOptions)?.flatMap(
      ({ countryCodes }) => countryCodes
    ) || []

  return availableCountries.includes(countryCode)
}
